import React from 'react';
import { ModalProvider } from 'react-modal-hook';
import { createBrowserRouter } from 'react-router-dom';
import { RoutePaths } from 'Interfaces/RoutePaths';
import SimplifiedWrapper from 'Layouts/SimplifiedWrapper';
import { UnderMaintenance } from 'Pages/UnderMaintenance';

const UnderMaintenanceRoutes = createBrowserRouter([
  {
    path: RoutePaths.BASE_PATH,
    element: (
      <ModalProvider>
        <SimplifiedWrapper />
      </ModalProvider>
    ),
    children: [{ index: true, element: <UnderMaintenance /> }],
  },
]);

export default UnderMaintenanceRoutes;
